import React from "react";
import styled from "@emotion/styled";

import LoanCalculator from "@components/loan-calculator";

function LoanCalculatorSection(props: any) {
  return (
    <Wrapper>
      <div className="container">
        <LoanCalculator disableLoanAmount={false} />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  border-radius: 200px 0px 0px 0px;
  position: relative;
  background-color: #f3f3f5;
  padding: 100px 0 130px;

  @media screen and (max-width: 991px) {
    border-radius: 150px 0px 0px 0px;
  }

  @media screen and (max-width: 570px) {
    border-radius: 0;
  }
`;

export default LoanCalculatorSection;
